<div class="search-bar">
  <form [formGroup]="searchForm" class="fields" (outsideClick)="activeInput = undefined">
    <div class="field where">
      <app-where formControlName="where" id="where" (click)="activeInput = 'where'" [active]="activeInput === 'where'"></app-where>
    </div>
    <div class="field when">
      <app-when formControlName="when" id="when" (click)="activeInput = 'when'" [active]="activeInput === 'when'"></app-when>
    </div>
    <div class="field who" style="height: 20px">
      <app-who formControlName="who" id="who" (click)="activeInput = 'who'" [active]="activeInput === 'who'"></app-who>
    </div>
  </form>
  <div>
    <ng-container *ngIf="isHostel(searchForm.value.where); else pwa">
      <a class="btn btn-theme" [routerLink]="['/hostels', searchForm.value.where.id]" [queryParams]="searchParams | async">
        <ng-container i18n>Search</ng-container>
      </a>
    </ng-container>
    <ng-template #pwa>
      <a class="btn btn-theme" [href]="pwaUrl | async">
        <ng-container i18n>Search</ng-container>
      </a>
    </ng-template>
  </div>
</div>
